module.exports = __webpack_public_path__ + "static/sentiment-83c237b22870e30a58224791e840057c.svg";